import { Component, OnInit } from '@angular/core';
import { Language } from 'app/service/coreModel';
import { LanguageService } from 'app/service/language.service';

@Component({
  selector: 'app-wnavbar',
  templateUrl: './wnavbar.component.pug',
  styleUrls: ['./wnavbar.component.scss']
})
export class WnavbarComponent implements OnInit {
  lang: string;
  langs: {}[];
  constructor(private _languageServ: LanguageService) {
    this.langs = Language.CODE;
    this._languageServ.get().subscribe(val => {
      this.lang = val;
    })
  }

  ngOnInit() {
  }

  changeLang(lang: string) {
    this._languageServ.setLang(lang);
  }

  linkToJPwebsite() {
    window.open('http://dexker.co/', '_self');
  }

  linkToShoppingwebsite() {
    window.open('https://dexker.1shop-app.com/', '_self');
  }
}
